module.exports = __webpack_public_path__ + "img/hero-bg.aaa3b5c.webp";